export default __webpack_public_path__ + "3c2b8500077893876b4074577ad5617a.png";